import React from 'react';
import { useTranslation } from 'react-i18next';
import './Footer.css';

const SSO_URL = process.env.REACT_APP_SSO_URL || 'https://auth.yuuu.es';

const Footer = () => {
  const { t, i18n } = useTranslation();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">
          <span className="footer-brand">OVERGUESSR</span>
          <div className="footer-links">
            <a
              href="https://liberapay.com/YuuuES"
              target="_blank"
              rel="noopener noreferrer"
              className="donation-button"
            >
              <i className="fas fa-donate"></i> {t('footer.donate', 'Donate')}
            </a>
            <a
              href={`${SSO_URL}/legal/cookies?lang=${i18n.language}&from=${window.location.origin}`}
              target="_blank" rel="noopener noreferrer"
              className="footer-link policy-link"
            >
              {t('footer.cookiePolicy')}
            </a>
            <a
              href={`${SSO_URL}/legal/privacy?lang=${i18n.language}&from=${window.location.origin}`}
              target="_blank" rel="noopener noreferrer"
              className="footer-link policy-link"
            >
              {t('footer.privacyPolicy')}
            </a>
            <a
              href={`${SSO_URL}/legal/terms?lang=${i18n.language}&from=${window.location.origin}`}
              target="_blank" rel="noopener noreferrer"
              className="footer-link policy-link"
            >
              {t('footer.termsConditions')}
            </a>
          </div>
        </div>
        <div className="footer-disclaimer">
          Made with Love &lt;3 for Overwatch Fans.
          <br />
          Not [yet] affiliated with Blizzard Entertainment. Overwatch is a trademark of Blizzard Entertainment, Inc.
          <br />
          Copyright © 2025{' '}
          <a href="https://yuuu.es" target="_blank" rel="noopener noreferrer" className="footer-link">
            Yuuu
          </a>
          . All rights reserved.
        </div>
        <div className="footer-discord">
          <a href="https://sh.yuuu.es/discord" target="_blank" rel="noopener noreferrer" className="discord-link">
            <i className="fab fa-discord"></i> Discord
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
